<template>
  <!-- 产品与服务 -->
  <div class="safeContent">
    <headerPage style="margin-top:0"></headerPage>
      <img style="width:100%;margin-top:5px" src="@/assets/img/aboutUsBg.jpg" alt />
    <!-- 数据云盒 -->
    <div class="sysIntro">
          <img style="display:inline-block;margin-top:90px;" src="@/assets/img/aboutUsBanner.jpg" alt="沁恒数联云盒">
           <div style="width:1200px;margin:48px auto;display:flex;justify-content:space-between;">
             <img src="@/assets/img/aboutUs.jpg" alt="">
             <div style="width:682px;height:849px;border:1px solid #E6E6E6;padding:30px 24px;text-align:left;color:#585757;">
                 <div>
                      <div class="title" >关于我们</div>
                      <div class="content" >
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;南京沁恒微电子股份有限公司是一家集成电路设计公司，成立于2004年，公司位于江苏南京。<br/>
                            自公司成立以来，我们始终以技术为导向，在物联网领域专注于连接和控制方面的芯片设计
                            及应用技术的研究和创新，致力于为客户提供万物互联，上下互通的芯片及解决方案。
                      </div>
                 </div>
                   <div style="margin-top:40px;">
                      <div class="title" >技术和产品</div>
                      <div class="content" >
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司主要产品包括：有线网络、无线网络、USB和PCI类接口芯片以及集成上述接口的单片机。
                        技术上涉及：模拟检测(ADC)、智能控制(MCU)、人机交互(HID/LED/LCD/TouchKey)、网络通信(Ethernet/BLE/Zigbee)、接口通讯(USB/PCI/PCIE)、
                        数据安全(U盘/SATA盘加密、单导、隔离)、物联协议(嵌入式协议栈、云端服务)，提供“感知+控制+连接+云聚”的解决方案。<br/>
                      </div>
                 </div>
                  <div style="margin-top:40px;">
                      <div class="title" >我们的优势</div>
                      <div class="content" >
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;沁恒的优势在于软件和硬件之间的无缝连接和协作、相互渗透和转化，并以此提供专业及高性价比的应用方案。
                        经过多年来的深耕，我们已向客户提供了百款产品及技术方案，全球已有1.2万家的公司采用沁恒芯片设计电子产品，每年至少有超亿台设备通过沁恒的产品建立连接，
                        沁恒是国内隔离卡、单向导入产品及方案的核心供应商，产品市场占有率超过90%，USB系列产品累计出货量超亿颗。<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;沁恒注重研发投入，每年研发投入占销售收入10%以上，通过创新获得专利、集成电路布图设计权、软件著作权等多项自主知识产权。
                        公司在注重研发投入和自主创新的同时，也十分注重自身品牌的建设，已在美国、英国、德国、日本、韩国、台湾、香港等多个国家和地区注册国际商标。沁恒被认定为国家高新技术企业、
                        集成电路设计企业、江苏省民营科技企业。<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;未来，我们将继续致力于技术创新，引领国内集成电路产业的发展，应对全球集成电路领域日新月异的挑战，成为您更专业、可信赖的合作伙伴。<br/>
                      </div>
                 </div>
                 <div style="margin-top:40px;">
                      <div style="line-height:30px;"><span class="littleWord">愿景</span> : 凝结智慧，改变生活</div>
                      <div style="line-height:30px;"><span class="littleWord">使命</span> : 凝结智慧，改变生活</div>
                      <div style="line-height:30px;"><span class="littleWord">核心价值观</span> : 凝结智慧，改变生活</div>
                 </div>
             </div>
           </div>
    </div>
    <!-- 底部 -->
     <footerPage style="width:100%;"></footerPage>

  </div>
</template>
<script>
import Vue from "vue";
import headerPage from "@/components/header.vue";
import footerPage from "@/components/footer.vue"
export default {
  components: {
    headerPage,
    footerPage
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped >
.headerContent {
  width: 100%;
  height: 590px;
  background: #f5f5f5;
  margin: 4px auto;
}
.sysIntro {
  width: 100%;
  margin: 0 auto;
  background: #F7FAFA;
  height: 1220px
}
.title{
  font-size: 18px;
  color: rgb(20, 130, 220); 
  font-family: arial,helvetica,sans-serif;
}
.content{
  margin-top:15px;
  line-height:30px;
  font-size:14px;
}
.littleWord{
  color: rgb(20, 130, 220); 
  font-family: arial,helvetica,sans-serif;
}
</style>


// WEBPACK FOOTER //
// src/view/aboutUs.vue